/* ==========================================================================
   MOHAR · Shopify theme shared behaviour
   Nav and footer now render server-side as Liquid sections (edit them in
   the theme editor). This file only handles page interactivity:
   reveal-on-scroll, accordions, the product gallery, the tap demo, the
   sticky buy bar, modal helpers, the entry note and the exit offer.
   Cart logic (add to cart / update / checkout) lives inline in the
   product and cart sections, because it needs real Shopify variant IDs.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function store(k, v) {
    try {
      if (v === undefined) { var r = sessionStorage.getItem(k); return r ? JSON.parse(r) : null; }
      sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }

  /* --------------------------------------------------------------- REVEAL */
  function reveal() {
    var items = $$('[data-rv]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    items.forEach(function (el, i) {
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------ ACCORDIONS */
  function accordions() {
    $$('.acc__i').forEach(function (item) {
      var q = $('.acc__q', item), a = $('.acc__a', item);
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });
  }

  /* --------------------------------------------------------------- GALLERY */
  function gallery() {
    $$('[data-gal]').forEach(function (g) {
      var slides = $$('.gal__main > *', g);
      var thumbs = $$('.gal__thumbs button', g);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          slides.forEach(function (s, j) {
            s.classList.toggle('is-on', i === j);
            var v = s.tagName === 'VIDEO' ? s : $('video', s);
            if (v) { if (i === j) { v.play().catch(function () {}); } else { v.pause(); } }
          });
          thumbs.forEach(function (b, j) { b.classList.toggle('is-on', i === j); });
        });
      });
    });
  }

  /* ------------------------------------------------------------ STICKY BAR */
  function stickyBuy() {
    var bar = $('[data-sticky]');
    var after = $('[data-sticky-after]');
    if (!bar || !after) return;
    var onScroll = function () {
      var past = after.getBoundingClientRect().bottom < 0;
      var atEnd = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 260);
      bar.classList.toggle('is-on', past && !atEnd);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------------------- TAP DEMO */
  function demo() {
    $$('.demo').forEach(function (d) {
      var btn = $('.tapbtn', d);
      var timer = null;

      function off() { d.classList.remove('is-on'); clearTimeout(timer); timer = null; }
      function on() {
        d.classList.add('is-on');
        clearTimeout(timer);
        timer = setTimeout(off, 6000);
      }
      function toggle() { if (d.classList.contains('is-on')) { off(); } else { on(); } }

      if (btn) {
        btn.addEventListener('click', toggle);
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            toggle();
          }
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { setTimeout(on, 700); io.unobserve(e.target); }
          });
        }, { threshold: .5 });
        io.observe(d);
      }
    });
  }

  /* Simple inline video play/pause toggle (used by testimonial video cards) */
  function inlinePlay() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-play]');
      if (!b) return;
      var v = b.parentNode.querySelector('video');
      if (!v) return;
      if (v.paused) { v.play(); b.style.opacity = '0'; } else { v.pause(); b.style.opacity = '1'; }
    });
  }

  /* --------------------------------------------------------- MODAL HELPERS */
  function openOvl(o) {
    o.classList.add('is-open');
    requestAnimationFrame(function () { o.classList.add('is-vis'); });
    document.body.style.overflow = 'hidden';
  }
  function closeOvl(o) {
    o.classList.remove('is-vis');
    setTimeout(function () { o.classList.remove('is-open'); document.body.style.overflow = ''; }, 300);
  }
  function wireOvl() {
    $$('.ovl').forEach(function (o) {
      o.addEventListener('click', function (e) { if (e.target === o) closeOvl(o); });
      $$('[data-close]', o).forEach(function (b) { b.addEventListener('click', function () { closeOvl(o); }); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var o = $('.ovl.is-open'); if (o) closeOvl(o); }
    });
  }

  /* ------------------------------------------------------------ CART DRAWER */
  /* A slide-in panel that shows what's in the bag. It is built once here
     and exposed as window.Mohar.cart so any page can open it:
       - Mohar.cart.render(cartJson) + Mohar.cart.open()  → after an add
       - Mohar.cart.open()                                → just show current bag
     The product section and mini-buybox snippet already POST to
     /cart/add.js with real variant IDs (they need Liquid-rendered IDs
     this file doesn't have), so this module only owns the drawer UI —
     one shared drawer, not one copy per page. */
  function cartDrawer() {
    var CART_URL = '/cart.js';
    var CHANGE_URL = '/cart/change.js';
    var ovl, body, foot, countEl;

    function build() {
      if (ovl) return;
      ovl = document.createElement('div');
      ovl.className = 'cartdrawer-ovl';
      ovl.innerHTML =
        '<div class="cartdrawer" role="dialog" aria-modal="true" aria-label="Your bag">' +
          '<div class="cartdrawer__head">' +
            '<h3>Your bag <span class="cartdrawer__count" data-drawer-count></span></h3>' +
            '<button class="cartdrawer__x" data-drawer-close aria-label="Close">' +
              '<svg class="ico" aria-hidden="true"><use href="#i-x"></use></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cartdrawer__body" data-drawer-body></div>' +
          '<div class="cartdrawer__foot" data-drawer-foot></div>' +
        '</div>';
      document.body.appendChild(ovl);
      body = $('[data-drawer-body]', ovl);
      foot = $('[data-drawer-foot]', ovl);
      countEl = $('[data-drawer-count]', ovl);

      ovl.addEventListener('click', function (e) { if (e.target === ovl) close(); });
      $('[data-drawer-close]', ovl).addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ovl.classList.contains('is-open')) close();
      });

      body.addEventListener('click', function (e) {
        var incr = e.target.closest('[data-drawer-incr]');
        var decr = e.target.closest('[data-drawer-decr]');
        var rm = e.target.closest('[data-drawer-remove]');
        if (incr) changeLine(incr.getAttribute('data-key'), 1);
        if (decr) changeLine(decr.getAttribute('data-key'), -1);
        if (rm) changeLine(rm.getAttribute('data-key'), -9999);
      });
    }

    function money(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }

    function render(cart) {
      build();
      countEl.textContent = cart.item_count ? '· ' + cart.item_count : '';
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

      if (!cart.items.length) {
        body.innerHTML =
          '<div class="cartdrawer__empty">' +
            '<svg class="ico" aria-hidden="true"><use href="#i-box"></use></svg>' +
            '<p>Your bag is empty.</p>' +
            '<button class="btn btn--green" type="button" data-drawer-close>Keep browsing</button>' +
          '</div>';
        foot.innerHTML = '';
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="line">' +
            '<div class="line__img"><img src="' + item.image + '" alt="" loading="lazy"></div>' +
            '<div>' +
              '<div class="line__t">' + item.product_title + '</div>' +
              (item.variant_title ? '<div class="line__s">' + item.variant_title + '</div>' : '') +
              '<div class="qty">' +
                '<button type="button" data-drawer-decr data-key="' + item.key + '" aria-label="Decrease quantity">–</button>' +
                '<b>' + item.quantity + '</b>' +
                '<button type="button" data-drawer-incr data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="line__rm" data-drawer-remove data-key="' + item.key + '">Remove</div>' +
            '</div>' +
            '<div class="line__r"><div class="line__p">' + money(item.final_line_price) + '</div></div>' +
          '</div>'
        );
      }).join('');

      foot.innerHTML =
        '<div class="srow srow--total"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div>' +
        '<p class="tiny">Pay on delivery available at checkout · Free delivery</p>' +
        '<a class="btn btn--green btn--block btn--lg" href="/checkout">Checkout</a>' +
        '<a class="btn btn--ghost btn--block" href="/cart">View full bag</a>';
    }

    function refresh() {
      return fetch(CART_URL, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    function open() {
      build();
      ovl.classList.add('is-open');
      requestAnimationFrame(function () { ovl.classList.add('is-vis'); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!ovl) return;
      ovl.classList.remove('is-vis');
      setTimeout(function () { ovl.classList.remove('is-open'); document.body.style.overflow = ''; }, 300);
    }

    function changeLine(key, delta) {
      var row = body.querySelector('[data-key="' + key + '"]').closest('.line');
      var current = Number($('.qty b', row).textContent);
      var next = Math.max(0, current + delta);
      fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { return r.json(); }).then(render);
    }

    // Any element on any page can open the drawer with the current bag.
    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-cart-open]');
      if (!openTrigger) return;
      e.preventDefault();
      refresh().then(open);
    });

    // Keep the nav bag-count badge correct on load without opening anything.
    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; }); })
      .catch(function () {});

    return { open: open, close: close, refresh: refresh, render: render };
  }

  /* ------------------------------------------------------------ ENTRY NOTE */
  /* One calm question, four pictures. Configure the four destinations and
     images with data attributes on <body data-entry-note='...'> if you
     want to reuse this, or simply remove the call to entryNote() below if
     you do not want the popup. Skips product/cart pages automatically. */
  function entryNote() {
    if (document.body.hasAttribute('data-no-nudge')) return;
    if (store('mohar_seen_note')) return;
    var cfgEl = $('[data-entry-note]');
    if (!cfgEl) return;
    if ($('[data-packs]') || $('[data-lines]')) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.getAttribute('data-entry-note')); } catch (e) { return; }
    if (!cfg || !cfg.cards || !cfg.cards.length) return;

    var cardsHtml = cfg.cards.map(function (c) {
      return '<a class="notecard" href="' + c.url + '"><img src="' + c.img + '" alt="' + (c.alt || '') + '" loading="lazy" decoding="async"><b>' + c.label + '</b></a>';
    }).join('');

    var o = document.createElement('div');
    o.className = 'ovl';
    o.innerHTML =
      '<div class="modal note"><div class="modal__wrap">' +
        '<button class="modal__x" data-close aria-label="Close"><svg class="ico" aria-hidden="true"><use href="#i-x"></use></svg></button>' +
        '<span class="eyebrow">One question</span>' +
        '<h3 class="d3">' + (cfg.heading || 'What keeps pulling you away?') + '</h3>' +
        '<p class="small muted mt3">Pick one and we will show you the page written for it. Nothing to sign up for.</p>' +
        '<div class="note__grid">' + cardsHtml + '</div>' +
        '<p class="tiny center mt5"><button data-close style="text-decoration:underline;text-underline-offset:3px">I am just looking around</button></p>' +
      '</div></div>';
    document.body.appendChild(o);
    o.addEventListener('click', function (e) { if (e.target === o) closeOvl(o); });
    $$('[data-close]', o).forEach(function (b) { b.addEventListener('click', function () { closeOvl(o); }); });

    var fired = false;
    function fire() {
      if (fired || $('.ovl.is-open')) return;
      fired = true;
      store('mohar_seen_note', 1);
      openOvl(o);
    }
    setTimeout(fire, 20000);
    window.addEventListener('scroll', function () {
      var d = document.documentElement;
      if ((window.scrollY / (d.scrollHeight - window.innerHeight)) > .4) fire();
    }, { passive: true });
  }

  /* ---------------------------------------------------- EXIT STUDENT OFFER */
  /* Fires only on the cart page, only when it is not empty, and only if a
     Google Apps Script endpoint is configured on <body data-exit-sheet-url>. */
  function exitOffer() {
    if (document.body.hasAttribute('data-no-exit')) return;
    if (store('mohar_exit_done')) return;

    var onCart = !!$('[data-lines]');
    if (!onCart) return;
    var hasItems = $$('[data-lines] [data-line]').length > 0;
    if (!hasItems) return;

    var sheetUrl = document.body.getAttribute('data-exit-sheet-url') || '';

    var o = document.createElement('div');
    o.className = 'ovl';
    o.innerHTML =
      '<div class="modal exit"><div class="modal__wrap">' +
        '<button class="modal__x" data-close aria-label="Close"><svg class="ico" aria-hidden="true"><use href="#i-x"></use></svg></button>' +
        '<div class="exit__top"><span class="exit__badge">Students only</span></div>' +
        '<div data-exit-form>' +
          '<span class="eyebrow mt5">Before you go</span>' +
          '<h3 class="d3">Studying? You do not pay full price.</h3>' +
          '<p class="small muted mt3">Leave your details and we will send you the student price on WhatsApp today.</p>' +
          '<form class="mt5" novalidate>' +
            '<div class="exit__row">' +
              '<input class="field" name="name" placeholder="Your name" autocomplete="name" required>' +
              '<input class="field" name="phone" placeholder="WhatsApp number" inputmode="tel" autocomplete="tel" required>' +
            '</div>' +
            '<input class="field" name="email" type="email" placeholder="Email (optional)" autocomplete="email">' +
            '<div class="exit__row">' +
              '<input class="field" name="studying" placeholder="What are you studying?">' +
              '<input class="field" name="institute" placeholder="College or coaching centre">' +
            '</div>' +
            '<p class="exit__err" data-err>Please add your name and a WhatsApp number.</p>' +
            '<button class="btn btn--green btn--block btn--lg" type="submit">Send me the student price</button>' +
            '<p class="tiny center">We message once. No spam, and we never sell your number.</p>' +
          '</form>' +
          '<p class="tiny center mt4"><button data-close style="text-decoration:underline;text-underline-offset:3px">No thanks, I am not a student</button></p>' +
        '</div>' +
        '<div class="exit__ok hide" data-exit-ok>' +
          '<svg class="ico" aria-hidden="true"><use href="#i-seal"></use></svg>' +
          '<h3 class="d3">Got it.</h3>' +
          '<p class="small muted mt3">We will WhatsApp you the student price today.</p>' +
          '<button class="btn btn--ghost mt5" data-close>Keep looking around</button>' +
        '</div>' +
      '</div></div>';
    document.body.appendChild(o);
    o.addEventListener('click', function (e) { if (e.target === o) closeOvl(o); });
    $$('[data-close]', o).forEach(function (b) { b.addEventListener('click', function () { closeOvl(o); }); });

    var form = $('form', o);
    var err = $('[data-err]', o);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = {};
      $$('input', form).forEach(function (i) { d[i.name] = i.value.trim(); });
      if (!d.name || d.phone.replace(/\D/g, '').length < 10) { err.classList.add('is-on'); return; }
      err.classList.remove('is-on');
      d.page = location.pathname;
      d.at = new Date().toISOString();
      if (sheetUrl) {
        fetch(sheetUrl, {
          method: 'POST', mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(d)
        }).catch(function () {});
      }
      store('mohar_exit_done', 1);
      $('[data-exit-form]', o).classList.add('hide');
      $('[data-exit-ok]', o).classList.remove('hide');
    });

    var fired = false;
    function fire() {
      if (fired || $('.ovl.is-open')) return;
      fired = true;
      openOvl(o);
    }
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY < 8) fire();
    });
    var lastY = 0, lastT = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now();
      if (lastT && y < lastY - 90 && (t - lastT) < 260 && y < 500) fire();
      lastY = y; lastT = t;
    }, { passive: true });
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', function () {
      if (!fired) { history.pushState(null, '', location.href); fire(); }
    });
    setTimeout(fire, 60000);
  }

  /* ------------------------------------------------------------- BOOTSTRAP */
  window.Mohar = { store: store, $: $, $$: $$, open: openOvl, close: closeOvl };

  function init() {
    reveal();
    accordions();
    gallery();
    stickyBuy();
    demo();
    inlinePlay();
    wireOvl();
    window.Mohar.cart = cartDrawer();
    entryNote();
    exitOffer();
    $$('[data-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('data-open'));
        if (t) openOvl(t);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/**
 * assets/mohar.js
 * Behaviour for the "Mohar — For work" section:
 *  - pack/variant selection (radio -> price + button text sync)
 *  - gallery (main image/video <-> thumbnails)
 *  - sticky buy bar (shows once the hero buybox scrolls out of view)
 *  - reveal-on-scroll ([data-rv] fade/slide in)
 *
 * No external deps. Runs once on DOMContentLoaded, and re-initialises
 * automatically if Shopify re-renders the section in the theme editor.
 */
(function () {
  'use strict';

  function init(root) {
    root = root || document;
    initPacks(root);
    initGallery(root);
    initSticky(root);
    initReveal(root);
  }

  /* ---------------------------------------------------------------- *
   * 1. PACKS / VARIANT PICKER
   * ------------------------------------------------------------------
   * Each [data-packs] block contains:
   *   - .pack labels, each with:
   *       <input type="radio" name="id" value="{{ variant.id }}">
   *       data-price="<numeric price>" on the label
   *   - a price display:   [data-price-now]
   *   - the add-to-bag button label: [data-atc-price]
   *   - optional sticky bar mirror: [data-stickyprice]
   * ------------------------------------------------------------------ */
  function initPacks(root) {
    var boxes = root.querySelectorAll('[data-packs]');

    boxes.forEach(function (box) {
      var packs = box.querySelectorAll('.pack');
      var priceNow = box.querySelector('[data-price-now]');
      var atcPrice = box.querySelector('[data-atc-price]');
      var stickyPrice = document.querySelector('[data-stickyprice]');

      if (!packs.length) return;

      // Click anywhere on the label (native <label> already checks the
      // radio, but we still need this to run for keyboard/programmatic
      // changes and to keep the .is-on class + prices in sync).
      packs.forEach(function (pack) {
        var input = pack.querySelector('input[type="radio"]');
        if (!input) return;

        pack.addEventListener('click', function () {
          input.checked = true;
          syncPacks();
        });

        input.addEventListener('change', syncPacks);
      });

      function syncPacks() {
        var active = null;

        packs.forEach(function (pack) {
          var input = pack.querySelector('input[type="radio"]');
          var isOn = !!(input && input.checked);
          pack.classList.toggle('is-on', isOn);
          if (isOn) active = pack;
        });

        if (!active) return;

        var formatted = formatMoney(active.getAttribute('data-price'));
        if (priceNow) priceNow.textContent = formatted;
        if (atcPrice) atcPrice.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = formatted;
      }

      // Run once on load so everything reflects whichever variant is
      // pre-selected server-side.
      syncPacks();
    });
  }

  // data-price is stored the same way Shopify's Liquid emits raw money
  // values: in the smallest currency unit (paise for INR), e.g. "149900"
  // for ₹1,499. It must be divided by 100 before formatting — this is
  // what the `money` Liquid filter and the inline buybox script both do.
  // (Previously this skipped the /100 step, so ₹1,499 rendered as
  // ₹1,49,900.00 the moment this script ran and overwrote the price.)
  function formatMoney(raw) {
    var value = parseFloat(raw);
    if (isNaN(value)) return '';
    return '₹' + (value / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  /* ---------------------------------------------------------------- *
   * 2. GALLERY
   * ------------------------------------------------------------------
   *   [data-gal]
   *     .gal__main > .slide (one per gallery block, first has .is-on)
   *     .gal__thumbs > button (one per gallery block, same order)
   * ------------------------------------------------------------------ */
  function initGallery(root) {
    var gals = root.querySelectorAll('[data-gal]');

    gals.forEach(function (gal) {
      var slides = gal.querySelectorAll('.gal__main .slide');
      var thumbs = gal.querySelectorAll('.gal__thumbs button');

      if (!slides.length || !thumbs.length) return;

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          if (thumb.classList.contains('is-on')) return;

          thumbs.forEach(function (t) { t.classList.remove('is-on'); });
          slides.forEach(function (s) { s.classList.remove('is-on'); });

          thumb.classList.add('is-on');
          if (slides[i]) {
            slides[i].classList.add('is-on');

            // (Re)play video slides when they become active.
            var video = slides[i].querySelector('video');
            if (video) {
              video.currentTime = 0;
              video.play().catch(function () {});
            }
          }
        });
      });
    });
  }

  /* ---------------------------------------------------------------- *
   * 3. STICKY BUY BAR
   * ------------------------------------------------------------------
   *   [data-sticky-after]  the hero block containing the real buybox
   *   [data-sticky]        the fixed bottom bar, toggled with .is-on
   * ------------------------------------------------------------------ */
  function initSticky(root) {
    var hero = root.querySelector('[data-sticky-after]');
    var bar = root.querySelector('[data-sticky]');
    if (!hero || !bar) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Show the sticky bar once the hero buybox has scrolled
          // past the top of the viewport; hide it while the hero
          // (and its own buttons) are still visible.
          bar.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );

    observer.observe(hero);
  }

  /* ---------------------------------------------------------------- *
   * 4. REVEAL ON SCROLL
   * ------------------------------------------------------------------
   *   Any element with [data-rv] gets .is-rv added once it enters
   *   the viewport (CSS handles the actual fade/slide transition).
   * ------------------------------------------------------------------ */
  function initReveal(root) {
    var items = root.querySelectorAll('[data-rv]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-rv'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-rv');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------- *
   * BOOT
   * ------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-init when the theme editor swaps this section back in.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();